export const environment = {
  production: true,
  api: 'https://api.auditorias.stage.globaluy.com',
  googleMapsApiKey: 'AIzaSyB38wb4x7iB-LsE7UoBpGGswT3S4VZUves',
};
